import React from "react";
import { Link } from "react-router-dom";
import { connect } from "alt-react";
import SettingsStore from "stores/SettingsStore";
import Translate from "react-translate-component";
import light from "assets/logo-404-light.png";
import dark from "assets/logo-404-dark.png";
import midnight from "assets/logo-404-midnight.png";

class Page404 extends React.Component {
  static defaultProps = {
    subtitle: "page_not_found_subtitle"
  };

  render() {
    let logo;

    if (this.props.theme === "lightTheme") {
      logo = light;
    }

    if (this.props.theme === "darkTheme") {
      logo = dark;
    }

    if (this.props.theme === "midnightTheme") {
      logo = midnight;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "page-404"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-404-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-404-logo"
    }, /*#__PURE__*/React.createElement("img", {
      src: logo,
      alt: "Logo"
    })), /*#__PURE__*/React.createElement("div", {
      className: "page-404-title"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "page404.page_not_found_title"
    })), /*#__PURE__*/React.createElement("div", {
      className: "page-404-subtitle"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "page404." + this.props.subtitle
    })), /*#__PURE__*/React.createElement("div", {
      className: "page-404-button-back"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, /*#__PURE__*/React.createElement(Translate, {
      component: "button",
      className: "button",
      content: "page404.home"
    })))));
  }

}

export default Page404 = connect(Page404, {
  listenTo() {
    return [SettingsStore];
  },

  getProps() {
    return {
      theme: SettingsStore.getState().settings.get("themes")
    };
  }

});